import React from 'react';
import Topnavigation from '../Layouts/Topnavigation';
import Content from '../Sections/Screen-D-Delivery-Orders-List/Content';
import { Helmet } from "react-helmet";

export default function ScreenDDeliveryOrdersList() {

    return (
        <div className="ms-body  ms-primary-theme ">
            {/* title */}
            <Helmet>
                <title>Orders</title>
            </Helmet>

            {/* sidebar start  */}
            {/* <Sidenavigation /> */}
            {/* sidebar end */}

            <main className="body-content">

                {/* Topnavigation start */}
                <Topnavigation />
                {/* Topnavigation end  */}

                {/* page content start  */}
                <Content Page='ScreenD' />
                {/* page content end  */}

            </main>

        </div>
    );
};